(function () {
  function getSelectedColor(section) {
    const variantSelects = document.querySelector(`variant-selects[data-section="${section}"]`);
    if (!variantSelects) return null;

    let colorValue = null;
    variantSelects.querySelectorAll('fieldset').forEach((fs) => {
      const legend = fs.querySelector('legend');
      const label = legend ? legend.textContent.trim().toLowerCase() : '';
      if (label.startsWith('color') || label.startsWith('colour')) {
        const checked = fs.querySelector('.cvo-input:checked');
        if (checked) colorValue = checked.value.trim().toLowerCase();
      }
    });
    return colorValue;
  }

  function shouldShow(mediaColor, color) {
    if (!mediaColor) return true;
    return mediaColor === color;
  }

  function runFilter(section) {
    const color = getSelectedColor(section);
    if (!color) return;

    const gallery = document.getElementById(`MediaGallery-${section}`);
    if (!gallery) return;

    if (typeof gallery.setActiveMedia !== 'function') {
      return;
    }

    const viewerItems = gallery.querySelectorAll('[id^="GalleryViewer"] li[data-media-id]');
    const thumbItems = gallery.querySelectorAll('[id^="GalleryThumbnails"] li[data-target]');

    let firstVisibleMediaId = null;

    viewerItems.forEach((li) => {
      const mediaColor = (li.dataset.mediaColor || '').toLowerCase();
      const visible = shouldShow(mediaColor, color);
      li.classList.toggle('gallery-item--hidden', !visible);
      if (visible && !firstVisibleMediaId) {
        firstVisibleMediaId = li.dataset.mediaId;
      }
    });

    thumbItems.forEach((li) => {
      const mediaColor = (li.dataset.mediaColor || '').toLowerCase();
      const visible = shouldShow(mediaColor, color);
      li.classList.toggle('gallery-item--hidden', !visible);
    });

    window.dispatchEvent(new Event('resize'));

    const activeItem = gallery.querySelector('[id^="GalleryViewer"] li.is-active');
    if (activeItem && activeItem.classList.contains('gallery-item--hidden') && firstVisibleMediaId) {
      gallery.setActiveMedia(firstVisibleMediaId, true);
    } else if (firstVisibleMediaId) {
      gallery.setActiveMedia(firstVisibleMediaId, false);
    }
  }

  // ✅ NEW: filter the zoom/product-media-modal as well
  function runModalFilter(section) {
    const color = getSelectedColor(section);
    if (!color) return;

    const modal = document.getElementById(`ProductModal-${section}`);
    if (!modal) return;

    const modalItems = modal.querySelectorAll('.product-media-modal__media-wrapper[data-media-id]');

    modalItems.forEach((wrapper) => {
      const mediaColor = (wrapper.dataset.mediaColor || '').toLowerCase();
      const visible = shouldShow(mediaColor, color);
      wrapper.classList.toggle('gallery-item--hidden', !visible);
    });
  }

  function filterGallery(section) {
    if (customElements.get('media-gallery')) {
      customElements.whenDefined('media-gallery').then(() => runFilter(section));
    } else {
      runFilter(section);
    }
    // ✅ modal ko bhi filter karo har baar
    runModalFilter(section);
  }

  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.type !== 'radio' || !input.classList.contains('cvo-input')) return;

    const fieldset = input.closest('fieldset');
    const legend = fieldset ? fieldset.querySelector('legend') : null;
    const label = legend ? legend.textContent.trim().toLowerCase() : '';
    if (!label.startsWith('color') && !label.startsWith('colour')) return;

    const section = input.closest('variant-selects')?.dataset.section;
    if (section) filterGallery(section);
  });

  function initAll() {
    document.querySelectorAll('variant-selects').forEach((vs) => {
      filterGallery(vs.dataset.section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('product-info:loaded', initAll);
  if (document.readyState !== 'loading') initAll();
})();